<template>
  <my-profile-menu-layout>
    <choose-avatar></choose-avatar>
  </my-profile-menu-layout>
</template>

<script>
  import MyProfileMenuLayout from "@/components/layout/MyProfileMenuLayout";
  import ChooseAvatar from "@/components/myprofile/ChooseAvatar";
  import CurrentUserMixin from "@/mixins/CurrentUserMixin";

  export default {
    name: "ProfileChooseAvatar",
    data() {
      return {
      }
    },
    mounted() {
      this.$store.commit('user/set_current_project_id', this.project_id)
    },
    mixins: [CurrentUserMixin],
    methods: {
    },
    components: {
      MyProfileMenuLayout, ChooseAvatar
    },
  }
</script>

<style scoped>

</style>